import EpochDatePicker from 'components/atoms/EpochDatePicker';
import React from 'react';
interface IProps {
    value: number | null;
    label: string | null;
    isRequired?: boolean;
    onChange: (date: number | null) => void;
    disabled?: boolean;
    format?: string;
    placeholder?: string;
    showToday?: boolean;
    className?: string;
    enabledDates?: { start?: number; end?: number } | null;
    allowedDays?: Number[];
}

const DatePicker: React.FC<IProps> = ({
    value,
    label,
    isRequired = false,
    onChange,
    disabled = false,
    format = 'MM/DD/YYYY',
    placeholder = 'Pick a date',
    showToday = false,
    className,
    enabledDates,
    allowedDays,
}) => {
    return (
        <div className={`flex ${label ? 'gap-1' : ''}"`}>
            <div className={`text-right flex gap-1 items-center`}>
                <>
                    {isRequired && <span className="text-redTriangle">*</span>}
                    {label ? `${label}:` : ''}
                </>
            </div>
            <EpochDatePicker
                value={value} // Pass the epoch timestamp
                onChange={onChange}
                format={format} // Specify date format
                classNames={`!rounded-md ${className}`}
                disabled={disabled}
                placeholder={placeholder}
                showToday={showToday}
                enabledDates={enabledDates}
                allowedDays={allowedDays}
            />
        </div>
    );
};

export default DatePicker;
